import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from './Modal'
const qs = require('qs')

const SUBJECT = 'I Need Your Help To Analyze Our Social Media Ad Accounts'
const BODY = 'I\'m interested in getting a preliminary performance analysis for our ad accounts, but don’t have direct access. Please visit http://www.unified.com/finallink to connect our account.'

export default class InviteModal extends Component {
	state = {
		toEmail: '',
		inviting: false,
		mailTo: ''
	}

	componentDidMount() {
		this.setState({
			mailTo: this.mailToStr('')
		})
	}

	mailToStr = (email) => {
		return 'mailto: ' + email + '?' + qs.stringify({
			subject: SUBJECT,
			body: BODY
		})
	}

	// Handle them dismissing the modal
	modalDismissed = () => {		
		this.props.modalDismissed()
		this.setState({toEmail: ''})
	}

	handleChange = (event) => {
		const email = event.target.value
		this.setState({mailTo: this.mailToStr(email), toEmail: email})
	}

	render() {
		const {toEmail, mailTo} = this.state
		return (
			<Modal display={this.props.display} modalDismissed={this.modalDismissed}>
				<Fragment>
					<img src="https://www.datocms-assets.com/3323/1528912402-mail.png" alt="mail icon" />
					<p>Forward this page to the team member or partner who has access to the ad account you would like to score.</p>
					<form>
						<input type="email" placeholder="Email Address" value={toEmail} onChange={this.handleChange} />
						<a className="cta" href={mailTo}>
							Invite Now
						</a>
					</form>
					<a className="account-invite" onClick={this.props.contactLinkClicked}>Don’t know who has access to your brand’s ad accounts? Click here.</a>
				</Fragment>
			</Modal>
		)
	}
}

InviteModal.propTypes = {
	display: PropTypes.bool.isRequired,
	modalDismissed: PropTypes.func.isRequired,
	sessionEmail: PropTypes.string.isRequired,
	contactLinkClicked: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/InviteModal.js